import React, { useState } from 'react';
import Footer from '../Components/Footer';
import Header from '../Components/Header';
import { NavLink } from 'react-router-dom';

import { createAppointment } from '../api/auth/bookAppointmentService';
function Bookingfordemo() {
    const [isDoctor, setIsDoctor] = useState(null); // null, true, or false

    const handleDoctorChange = (value) => {
        setIsDoctor(value);
    };

    const [values, setValues] = React.useState({
        name: "",
        email: "",
        phone: "",
        subject: "",
        address: "",
        message: "",
        date: ""

    });

    const handleChanges = (e) => {
        const { name, value } = e.target;
        setValues({
            ...values,
            [name]: value
        });
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        const currentDate = new Date().toISOString().split("T")[0];

        const payload = {
            ...values,
            date: currentDate
        };
        try {
            const response = await createAppointment(payload);

            console.log(response.data);
            alert("Message sent successfully!");
            setValues({
                name: "",
                email: "",
                phone: "",
                subject: "",
                address: "",
                message: "",
                date: ""

            });
        } catch (error) {
            console.error("There was an error sending the message!", error);
            alert("Message not sent");
        }
    };
    return (
        <div>
            <Header />
            <div className="breadcrumbs overlay">
                <div className="container">
                    <div className="bread-inner">
                        <div className="row">
                            <div className="col-12">
                                <h2>Book Appointment</h2>
                                <ul className="bread-list">
                                    <li><NavLink to='/'>Home</NavLink></li>
                                    <li><i className="icofont-simple-right" /></li>
                                    <li className="active">Book Appointment</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <section className="appointment">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section-title">
                                <h2>Book An Appointment For Demo</h2>
                                <img src="img/section-img.png" alt="#" />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-5 col-md-12">
                            <div className="appointment-image" style={{ width: "100%" , borderRadius: "5px" }}>
                                <img src="img/BookAppointment.png" alt="Book Appointment" />
                            </div>
                        </div>
                        <div className="col-lg-7 col-md-12 col-12">
                            <h6>
                                Are You A Doctor?{" "}

                                <input
                                    type="checkbox"
                                    checked={isDoctor === true}
                                    onChange={() => handleDoctorChange(true)}
                                />{" "}

                                Yes{" "}
                                <input
                                    type="checkbox"
                                    checked={isDoctor === false}
                                    onChange={() => handleDoctorChange(false)}
                                />{" "}
                                No
                            </h6>

                            {isDoctor === false && (
                                <div style={{ color: "blue", marginBottom: "15px" }}>
                                    Please contact support at <strong>8051316666</strong> or email us at{" "}
                                    <a href="mailto:support@webnettechnoligies.com">support@webnettechnoligies.com</a>
                                </div>
                            )}

                            <form className="form" onSubmit={handleSubmit} style={{ pointerEvents: isDoctor ? "auto" : "none", opacity: isDoctor ? 1 : 0.5 }}>
                                <div className="row">
                                    <div className="col-lg-6 col-md-6 col-12">
                                        <div className="form-group">
                                            <input name="name" type="text" placeholder="Name" disabled={!isDoctor} onChange={handleChanges}
                                                value={values.name}
                                                required />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-12">
                                        <div className="form-group">
                                            <input name="phone" type="text" placeholder="Phone" disabled={!isDoctor} onChange={handleChanges}
                                                value={values.phone}
                                                required />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-12">
                                        <div className="form-group">
                                            <input name="email" type="email" placeholder="Email" disabled={!isDoctor} onChange={handleChanges}
                                                value={values.email}
                                                required />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-12">
                                        <div className="form-group">
                                            <input name="subject" type="text" placeholder="Subject" disabled={!isDoctor} onChange={handleChanges}
                                                value={values.subject}

                                                required />
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-md-6 col-12">
                                        <div className="form-group">
                                            <input name="address" type="text" placeholder="Address" disabled={!isDoctor} onChange={handleChanges}
                                                value={values.address}
                                                required />
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-md-12 col-12">
                                        <div className="form-group">
                                            <textarea name="message" placeholder="Write Your Message Here....." disabled={!isDoctor} onChange={handleChanges}
                                                value={values.message}
                                                required></textarea>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-5 col-md-4 col-12">
                                        <div className="form-group">
                                            <div className="button">
                                                <button type="submit" className="btn btn-primary" disabled={!isDoctor}>Book An Appointment</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-7 col-md-8 col-12">
                                        <p>( We will confirm by a Text Message )</p>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
}

export default Bookingfordemo;
